// ==========================================================================
// JavaScript SVGInliner
// Author: Globalia
// Licensed under the WTFPL license
// ==========================================================================

import {
    toggleAttributeValue,
    removeAttributeValue
} from 'groots/utilities';

class GrInlineSVG {
    constructor(selector) {
        this.pluginName = 'grInlineSVG';

        // Create global references
        this.name = this.pluginName;
        this.selector = typeof selector === 'string' ? document.querySelector(selector) : selector;

        this.init();
    }

    init() {
        if (this.selector === null) {
            throw new Error(this.pluginName + ': fail - something wrong with your selector');
        } else {
            var image = this.selector;
            var url = image.src || image.getAttribute('data-src');
            var attributes = image.attributes;
            var httpRequest = new XMLHttpRequest();
            image.setAttribute('gr-svg-inliner', 'ready');

            if (window.groots.verbose) {
                console.warn('grInlineSVG(' + url + '): ready');
            }

            httpRequest.onreadystatechange = function() {
                toggleAttributeValue(image, 'gr-svg-inliner', 'processing');

                // readyState 4 = complete
                if (httpRequest.readyState === 4) {

                    if (httpRequest.status === 404 || httpRequest.responseXML === null) {
                        console.warn('Unable to load SVG file: ' + url);
                        return false;
                    }

                    if (httpRequest.status === 200) {
                        var xmlDoc;

                        try {
                            var parser = new DOMParser();
                            xmlDoc = parser.parseFromString(httpRequest.responseText, 'text/xml');
                        } catch (e) {
                            xmlDoc = undefined;
                        }

                        if (!xmlDoc || xmlDoc.getElementsByTagName('parsererror').length) {
                            console.warn('Unable to parse SVG file: ' + url);
                            return false;
                        } else {
                            var svg = xmlDoc.documentElement;

                            // Remove some of the attributes that aren't needed
                            svg.removeAttribute('xmlns:a');
                            svg.removeAttribute('width');
                            svg.removeAttribute('height');
                            svg.removeAttribute('x');
                            svg.removeAttribute('y');
                            svg.removeAttribute('enable-background');
                            svg.removeAttribute('xmlns:xlink');
                            svg.removeAttribute('xml:space');
                            svg.removeAttribute('version');

                            // Add the attributes from the original <img> except src, alt or class
                            Array.prototype.slice.call(attributes).forEach(function(attribute) {
                                if (attribute.name !== 'src' && attribute.name !== 'alt') {
                                    svg.setAttribute(attribute.name, attribute.value);
                                }
                            });

                            // Add accessibility attributes
                            if (attributes.alt) {
                                svg.setAttribute('aria-labelledby', 'title');

                                var title = document.createElementNS('http://www.w3.org/2000/svg', 'title');
                                var titleText = document.createTextNode(attributes.alt.value);

                                title.appendChild(titleText);
                                svg.insertBefore(title, svg.firstChild);
                            }

                            svg.setAttribute('role', 'img');
                            svg.setAttribute('gr-svg-inliner-src', url);

                            // Replace the image with the svg
                            image.parentNode.replaceChild(svg, image);

                            removeAttributeValue(svg, 'gr-svg-inliner', 'processing');
                            toggleAttributeValue(svg, 'gr-svg-inliner', 'done');

                            if (window.groots.verbose) {
                                console.warn('grInlineSVG(' + url + '): done');
                            }
                        }
                    }
                }
            };

            if (window.groots.verbose) {
                httpRequest.onerror = function() {
                    console.warn('grInlineSVG: failed - connection error');
                };
            }

            httpRequest.open('GET', url, true);

            // Treat and parse the response as XML, even if the server sends us a different mimetype
            if (httpRequest.overrideMimeType) {
                httpRequest.overrideMimeType('text/xml');
            }

            httpRequest.send();
        }
    }

    // Destroy - remove listeners to prevent from memory leak
    destroy() {
        removeAttributeValue(this.selector, 'gr-svg-inliner', 'ready processing done');

        if (window.groots.verbose) {
            console.warn(this.pluginName + ': destroyed');
        }
    }
}

export default GrInlineSVG;

//  Auto-Instantiation
// ----------------------------------------------------------------------

(function() {
    const all = document.querySelectorAll('[gr-svg-inliner]');
    window.groots.plugins.grInlineSVG = {};

    if (all.length) {
        window.groots.plugins.grInlineSVG.instances = {};
        let index = -1;

        while (all[++index]) {
            window.groots.plugins.grInlineSVG.instances[index] = new GrInlineSVG(all[index]);
        }
    }
}());
